import { ref } from 'vue'
import { useApiData } from '@/composables/useApiData'
import { useCachedFetch } from '@/composables/useFetch'

const FORECASTERS_URL = 'https://cdn-consumer.weatherflow.com/pro-forecasts/forecasters/json-api/forecasters.json'

export const useApiProForecast = () => {
  const apiProForecastData = useApiData('forecast')

  async function getAvailable(lat, lon) {
    const options = { type: 'all' }

    if (lat) options.lat = lat
    if (lon) options.lon = lon

    return await apiProForecastData.request('getAvailableOperationalForecasts', options)
  }

  async function getForecast(forecastId, { sample = false, ...params } = {}) {
    const options = { ...params }

    if (forecastId) options.forecast_id = forecastId

    const endpoint = sample ? 'getOperationalForecastSample' : 'getOperationalForecast'

    return await apiProForecastData.request(endpoint, options)
  }

  async function getForecasters() {
    let data = ref(null)
    let error = ref(null)

    try {
      ({ data, error } = await useCachedFetch(FORECASTERS_URL))

      if (error.value) throw error.value
    } catch (err) {
      console.warn(err)

      if (!error.value) error.value = err
    }

    return { data, error }
  }

  return {
    getAvailable,
    getForecast,
    getForecasters
  }
}
